import { ShareBaseDocument } from 'phoenix/domain';
import { LocalizedResourcesService } from 'phoenix/services';
import { ShareBaseDialog } from 'sharebase/domain';

const template = require('./launchDialog.template');
require('./launchDialog.styles');

export class LaunchDialog extends ShareBaseDialog {
	public static $inject = [
		'$mdDialog',
		'$timeout',
		'$window',
		'pxLocalizedResourcesService',
		'gettextCatalog'
	];

	public documentName:string;

	constructor(
		$mdDialog:ng.material.IDialogService,
		private $timeout:ng.ITimeoutService,
		private $window:ng.IWindowService,
		private pxLocalizedResourcesService:LocalizedResourcesService,
		gettextCatalog:ng.gettext.gettextCatalog
	) {
		super($mdDialog, template, gettextCatalog.getString('Launching Microsoft Online'));
	}

	public show(document:ShareBaseDocument, event?:ng.IAngularEvent) {
		this.documentName = document.DocumentName;
		
		this.$timeout(() => super.dismiss(), 10000);
		return super
			.open(event)
			.catch(e => super.dismiss());
	}

	public learnMore() {
		this.$window.open(this.pxLocalizedResourcesService.termsOfService, '_blank');
	}
}



// WEBPACK FOOTER //
// ./src/office-online/components/launchDialog/launchDialog.ts